const middleware = {}

middleware['headers'] = require('../middleware/headers.ts')
middleware['headers'] = middleware['headers'].default || middleware['headers']

middleware['pathHandler'] = require('../middleware/pathHandler.ts')
middleware['pathHandler'] = middleware['pathHandler'].default || middleware['pathHandler']

export default middleware
